import React from "react";
import { generateUniqueId } from "../../../store/utility";

export default function DynamicKeyValue(props) {
  const data = props.dataObj ? props.dataObj : {};
  const setData = props.setDataObj;

  const addRow = () => {
    let rowId = generateUniqueId(7);
    let newRow = { key: "", value: "" };
    if (!data[rowId]) {
      setData({ ...data, [rowId]: newRow });
    }
  };

  const deleteRow = (rowId) => {
    let rows = { ...data };
    delete rows[rowId];
    setData(rows);
  };
  const handleChange = (e, rowId, property) => {
    let value = e.target.value;
    let rows = { ...data };
    rows[rowId][property] = value;
    setData(rows);
  };
  const setRows = () => {
    let rows = [];
    for (let rowKey in data) {
      let rowData = data[rowKey];
      rows.push(
        <div className="form-row" key={rowKey}>
          <div className="form-group col-md-4">
            <input
              className="form-control "
              placeholder="key"
              value={rowData.key}
              onChange={(e) => handleChange(e, rowKey, "key")}
            />
          </div>
          <div className="form-group col-md-7">
            <input
              className="form-control"
              placeholder="value"
              value={rowData.value}
              onChange={(e) => handleChange(e, rowKey, "value")}
            />
          </div>
          <div>
            <button
              className="btn btn-danger btn-sm form-control"
              onClick={() => deleteRow(rowKey)}
            >
              X
            </button>
          </div>
        </div>
      );
    }
    return rows;
  };
  return (
    <div>
      <button
        className="btn btn-secondary btn-sm mb-4"
        onClick={addRow}
        type="button"
      >
        Add Additional Info
      </button>

      {setRows()}
    </div>
  );
}
